// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const jirachi: PokeData = {
  "id": 385,
  "name": "jirachi",
  "height": 3,
  "weight": 11,
  "base_experience": 270,
  "types": [
    PokeType.STEEL,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "double-edge",
    "confusion",
    "psychic",
    "swift",
    "rest",
    "future-sight",
    "helping-hand",
    "wish",
    "refresh",
    "meteor-mash",
    "cosmic-power",
    "doom-desire",
    "gravity",
    "healing-wish",
    "lucky-chant",
    "last-resort",
    "zen-headbutt",
    "life-dew"
  ],
  "moves": [
    "psychic",
    "future-sight",
    "refresh",
    "meteor-mash",
    "healing-wish",
    "zen-headbutt",
    "life-dew",
    "magnet-pull",
    "iron-defense",
    "metal-sound",
    "behemoth-bash",
    "magnet-bomb"
  ],
  "evolution_chain": {
    "id": 201,
    "item": null,
    "species": [
      {
        "name": "jirachi",
        "order": 415,
        "types": [
          PokeType.STEEL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 133,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
